var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasConfig && _vm.hasSchedule && !_vm.loading
    ? _c("div", { staticClass: "alert alert-danger" }, [
        _c("p", [
          _c("i", { staticClass: "fa fa-info-circle" }),
          _vm._v(" "),
          _c("strong", [_vm._v("Autoprovisioning Active:")]),
          _vm._v(" This domain has autoprovisioning configured using \n    "),
          _c("strong", [
            _vm._v(_vm._s(_vm.formatRosterService(_vm.rosterService)))
          ]),
          _vm._v(
            ".\n    1) Do not send a spreadsheet for user updates. 2) Do not manually set up or edit accounts for this domain.\n  "
          )
        ])
      ])
    : _vm.hasConfig && !_vm.hasSchedule && !_vm.loading
    ? _c("div", { staticClass: "alert alert-warning" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("i", { staticClass: "fa fa-info-circle" }),
      _vm._v(" "),
      _c("strong", [_vm._v("Autoprovisioning Setup Incomplete:")]),
      _vm._v(
        " This domain may need manual spreadsheets for now but will transition to automated provisioning in the future. See User Provisioning tab in Salesforce for more details.\n  "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }